import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './app/App'
import { AuthGate } from './modules/auth/components/AuthGate'

import './styles/globals.css'

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration may fail in private mode / unsupported browsers — silent
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </React.StrictMode>
)
